exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".step-form-wrapper[data-v-798ef406] {\n  margin: 0 auto;\n  width: 80%;\n  max-width: 400px;\n}\n", ""]);

// exports
